import Lenis from 'lenis'
import 'lenis/dist/lenis.css'
let instance, frame, stopWatcher, paused = false, held = false
let readyPath
const readyListeners = new Set()
export function pageReady(path) {
  readyPath = path
  for (const listener of readyListeners) listener(path)
}
// 換頁時等新頁掛載。2026-09-25 動態設計：不再等兩個 rAF。
// ① View Transition 更新期間瀏覽器暫停繪製、rAF 不跑；② 新頁要在第一次繪製「之前」就捲到定位
// （舊版先用舊的捲動位置畫兩幀再跳頂，只是被 0.5s 淡出黑幕蓋住）。scrollTo 會強制排版，同步就量得到高度。
export function waitForPage(path, { timeout = 1800 } = {}) {
  return new Promise(resolve => {
    const finish = current => {
      if (current !== path) return
      readyListeners.delete(finish)
      clearTimeout(timer)
      queueMicrotask(resolve)
    }
    const timer = setTimeout(() => finish(path), timeout)
    readyListeners.add(finish)
    if (readyPath === path) finish(path)
  })
}
export function startSmoothScroll() {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)')
  const configure = () => {
    cancelAnimationFrame(frame)
    instance?.destroy()
    instance = null
    if (reduced.matches) return
    instance = new Lenis({ smoothWheel: true, syncTouch: false, allowNestedScroll: true,
      prevent: node => node.closest?.('dialog, .mobile-menu-overlay, [data-lenis-prevent], input, textarea, select') })
    if (paused || held) instance.stop()
    const raf = time => { instance?.raf(time); frame = requestAnimationFrame(raf) }
    frame = requestAnimationFrame(raf)
  }
  configure()
  reduced.addEventListener('change', configure)
  stopWatcher = () => reduced.removeEventListener('change', configure)
  return () => { stopWatcher?.(); cancelAnimationFrame(frame); instance?.destroy(); instance = null }
}
export function pauseSmoothScroll(value) { paused = value; if (paused) instance?.stop(); else if (!held) instance?.start() }
// 換頁轉場期間停住 Lenis 的慣性（不把還在滑的畫面拍進快照），轉場結束再放開。
// html.vt-hold 讓 lenis-stopped 的 overflow:clip 不生效——否則捲軸消失、整頁寬度在轉場中跳一下。
export function holdSmoothScroll(value) {
  held = value
  document.documentElement.classList.toggle('vt-hold', value)
  if (held) instance?.stop()
  else if (!paused) instance?.start()
}
const easeInOutCubic = t => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2)
// smooth：頁內錨點滑行（與 Lab 相機同一條 560ms easeInOutCubic）；沒有 Lenis（減少動態）一律瞬移。
export function scrollPage(top, left = 0, { smooth = false } = {}) {
  if (instance) {
    instance.resize()
    if (smooth) instance.scrollTo(top, { duration: 0.56, easing: easeInOutCubic, force: true })
    else instance.scrollTo(top, { immediate: true, force: true })
  } else window.scrollTo({ top, left, behavior: 'instant' })
}
// 錨點：目標上緣留出頁首高度＋24px（取代寫死的 −100）
export function hashTarget(hash) { try { return document.getElementById(decodeURIComponent(String(hash).replace(/^#/, ''))) } catch { return null } }
// 頁面自己還有黏在頁首下的列（標 data-anchor-offset，例如履歷頁手機目錄）時，再讓出它的高度；display:none 的不算
export function scrollToElement(target, { smooth = false } = {}) {
  const sticky = [...document.querySelectorAll('[data-anchor-offset]')].reduce((h, el) => (el.offsetParent ? Math.max(h, el.offsetHeight) : h), 0)
  const offset = (document.querySelector('.site-header')?.offsetHeight || 76) + 24 + sticky
  scrollPage(target.getBoundingClientRect().top + window.scrollY - offset, 0, { smooth })
}
